/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import useForm from "../../../hooks/useForm";
import Modal, { ModalHeader } from "../../../components/Modal";
import Form from "../../../components/Form";
import { createExpenseOption } from "../../../apis/expense";


const ExpenseOptionDetail = ({ data, mode = "create", open, setOpen, submit }) => {

  const [fields, setields] = useState([]);

  useEffect(() => {
    setields([
      [{ title: "항목명", key: "name", type: "input", required: true }],
    ]);
  }, []);

  const _submit = (_form) => {
    
    if (mode === "create") {
      console.log("_form: ", _form)

      createExpenseOption(_form)
        .then(() => {
          cancel()
        })
    }

    if (mode === "modify") {
    }
  };

  const defaultForm = {
    name: mode === "create" ? "" : data.name,
  }

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    resetForm(defaultForm)
    if (submit) {
      submit()
    }
  };

  
  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    resetForm,
    //setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setValidateFields(fields)
  }, [fields])

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="grade-write">
        <ModalHeader>항목 {mode === "create" ? "작성" : "수정"}</ModalHeader>
        <Form
          mode={mode}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '작성' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
      
    </Modal>
  );
};

export default ExpenseOptionDetail;
